import { useState, useEffect } from "react";
import Header from "../components/Header/Header";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import "../styles/CreateMatch.css";
import { useNavigate } from "react-router-dom";

// Configuration automatique de l'API
// Utilise HTTPS en production pour éviter les problèmes de Mixed Content
const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:3001/api'
  : `${window.location.protocol}//${window.location.hostname}/api`;

export default function CreateMatch() {
  const [matchTypes, setMatchTypes] = useState([]);
  const [selectedMatchType, setSelectedMatchType] = useState('');
  const [lieuMatch] = useState(["Domicile", "Exterieur"]);
  const [selectedLieu, setSelectedLieu] = useState('');
  const [players, setPlayers] = useState([]);
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [adversaire, setAdversaire] = useState('');
  const navigate = useNavigate();


  useEffect(() => {
    // Changer le titre de la page
    document.title = 'ESMANAGER - NOUVEAU MATCH';
    
    fetch(`${API_URL}/match-types`)
      .then(res => res.json())
      .then(data => {
        setMatchTypes(data);
      })
      .catch(err => {
        // Erreur silencieuse
      });
  }, []);

  useEffect(() => {
    fetch(`${API_URL}/players`)
      .then(res => res.json())
      .then(data => {
        setPlayers(data);
      })
      .catch(err => {
        // Erreur silencieuse
      });
  }, []);

  return (
    <div>
      <Header />
      <h1>NOUVEAU MATCH</h1>
      <Box maxWidth={600} mx="auto" px={2}>
        <TextField
          id="adversaire"
          label="Adversaire"
          variant="standard"
          fullWidth
          value={adversaire}
          onChange={(e) => setAdversaire(e.target.value)}
          sx={{
            "& .MuiInput-underline:before": {
              borderBottomColor: "#211b3f",
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
              borderBottomColor: "#211b3f",
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#211b3f",
            },
          }}
        />
        <Box sx={{ mt: 2, mb: 2 }}>
        <h3>Type de match</h3>
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'row', 
            gap: 2,
            flexWrap: 'nowrap',
            overflowX: 'auto'
          }}>
            {matchTypes.map((type) => (
              <Button
                key={type.rowid}
                variant={selectedMatchType === type.rowid.toString() ? "contained" : "outlined"}
                onClick={() => setSelectedMatchType(type.rowid.toString())}
                sx={{
                  borderColor: '#211b3f',
                  color: selectedMatchType === type.rowid.toString() ? 'white' : '#211b3f',
                  backgroundColor: selectedMatchType === type.rowid.toString() ? '#211b3f' : 'transparent',
                  '&:hover': {
                    borderColor: '#211b3f',
                    backgroundColor: selectedMatchType === type.rowid.toString() ? '#211b3f' : 'rgba(33, 27, 63, 0.1)',
                  },
                  textTransform: 'none',
                  fontWeight: 'medium',
                  px: 3,
                  py: 1
                }}
              >
                {type.label}
              </Button>
            ))}
          </Box>
        </Box>


         <Box sx={{ mt: 2, mb: 2 }}>
           <h3>Lieu</h3>
           <Box sx={{ 
             display: 'flex', 
             flexDirection: 'row', 
             gap: 2,
             flexWrap: 'nowrap',
             overflowX: 'auto'
           }}>
             {lieuMatch.map((lieu) => (
               <Button
                 key={lieu}
                 variant={selectedLieu === lieu ? "contained" : "outlined"}
                 onClick={() => setSelectedLieu(lieu)}
                 sx={{
                   borderColor: '#211b3f',
                   color: selectedLieu === lieu ? 'white' : '#211b3f',
                   backgroundColor: selectedLieu === lieu ? '#211b3f' : 'transparent',
                   '&:hover': {
                     borderColor: '#211b3f',
                     backgroundColor: selectedLieu === lieu ? '#211b3f' : 'rgba(33, 27, 63, 0.1)',
                   },
                   textTransform: 'none',
                   fontWeight: 'medium',
                   px: 3,
                   py: 1
                 }}
               >
                 {lieu}
               </Button>
             ))}
           </Box>
         </Box>

          <Box sx={{ mt: 2, mb: 2 }}>
            <h3 style={{ color: '#211b3f', marginBottom: '16px' }}>Joueurs</h3>
            {players.map((player) => (
              <ListItem
                key={player.rowid}
                sx={{ 
                  px: 0,
                  py: 1,
                  borderBottom: '1px solid #f0f0f0'
                }}
              >
                <ListItemAvatar>
                  <Avatar 
                    sx={{ 
                      bgcolor: '#1976d2',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '0.9rem'
                    }}
                  >
                    {player.firstname?.charAt(0)}{player.lastname?.charAt(0)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography 
                      variant="h6" 
                      sx={{ 
                        fontWeight: 'medium',
                        fontSize: '1rem'
                      }}
                    >
                      <span style={{ fontStyle: 'italic' }}>{player.firstname}</span>{' '}
                      <span style={{ textTransform: 'uppercase' }}>{player.lastname}</span>
                    </Typography>
                  }
                  secondary={
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: '#666',
                        fontStyle: 'italic',
                        fontSize: '0.85rem'
                      }}
                    >
                      {player.label}
                    </Typography>
                  }
                />
                <Checkbox
                  checked={selectedPlayers.includes(player.rowid)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedPlayers([...selectedPlayers, player.rowid]);
                    } else {
                      setSelectedPlayers(selectedPlayers.filter(id => id !== player.rowid));
                    }
                  }}
                  sx={{ 
                    color: '#211b3f',
                    '&.Mui-checked': {
                      color: '#211b3f',
                    }
                  }}
                />
              </ListItem>
            ))}
          </Box>

           <Button 
             onClick={() => {
               // Préparer les données du match
               const matchTypeLabel = matchTypes.find(type => type.rowid.toString() === selectedMatchType)?.label;
               
               const matchData = {
                 adversaire,
                 matchType: selectedMatchType,
                 matchTypeLabel,
                 lieu: selectedLieu,
                 selectedPlayers
               };

               // Naviguer vers la page de composition avec les données
               navigate("/composition", { 
                 state: { 
                   matchData,
                   selectedPlayers 
                 } 
               });
             }}
             variant="contained"
             disabled={!adversaire || !selectedMatchType || !selectedLieu}
             sx={{
               backgroundColor: '#211b3f',
               '&:hover': {
                 backgroundColor: '#1a1530',
               },
               mt: 3,
               py: 1.5,
               px: 4
             }}
           >
             Suivant
           </Button>

      </Box>
    </div>
  );
}